import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group row align-items-start mb-4" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bolder" }, "Fecha de registro", -1)
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bolder" }, "Nro. de folios", -1)
const _hoisted_6 = { class: "form-group row mb-3" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bolder" }, "Asunto", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "text-dark font-weight-bold mb-4" }, " Adjuntar documentación: ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip bg-light-success mt-5 p-4 border rounded text-black" }, " Se pueden anexar archivos de hasta (5) megas como máximo en formato PDF. ", -1)
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Subsanar ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Espere un momento... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open_dialog_rectify,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.open_dialog_rectify) = $event)),
    title: 'Levantar observación del expediente Nº ' + _ctx.expediente.nro_proceedings,
    draggable: "",
    onOpen: _ctx.onOpen,
    top: "4vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          ref: "submitButton",
          class: "btn btn-custom btn-primary btn-sm me-2",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, _hoisted_14, 512),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-custom btn-danger btn-sm",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open_dialog_rectify = false))
        }, " Cerrar ")
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "ruleFormRef",
        model: _ctx.form,
        rules: _ctx.rules,
        class: "form form-label-right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.created_at,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.created_at) = $event)),
                class: "w-100",
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_form_item, { prop: "nrofolios" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.nrofolios,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.nrofolios) = $event)),
                    modelModifiers: { number: true },
                    type: "text",
                    autocomplete: "off",
                    maxlength: 4
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_form_item, { prop: "message" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.message,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.message) = $event)),
                    placeholder: "Ingrese aquí el detalle",
                    rows: 4,
                    "show-word-limit": "",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_9,
          _createVNode(_component_el_upload, {
            ref: "upload",
            headers: _ctx.headers,
            name: "file",
            action: `${_ctx.urlUpload}api/file/upload`,
            accept: ".pdf",
            limit: 5,
            "on-exceed": _ctx.handleExceed,
            "before-upload": _ctx.beforeUpload,
            "on-error": _ctx.handleError,
            "on-success": _ctx.handleSuccess,
            "auto-upload": true
          }, {
            tip: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, { type: "success" }, {
                default: _withCtx(() => [
                  _createTextVNode("Seleccionar archivos")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["headers", "action", "on-exceed", "before-upload", "on-error", "on-success"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onOpen"]))
}